module.exports = __webpack_public_path__ + "img/bardian_box5_bg.94e722c4.jpg";